import React from "react";
import {
  Table,
  Paper,
  TableRow,
  TableBody,
  TableCell,
  IconButton,
  TableContainer,
  TableHead,
} from "@mui/material";
// components

import moment from "moment";
import Iconify from "../iconify";

const ActivePrizeDrawTable = ({ rows, handleOpenMenu }) => {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Title</TableCell>
            <TableCell>Draw Date</TableCell>
            <TableCell>Start Date</TableCell>
            <TableCell>End Date</TableCell>
            <TableCell>Featured</TableCell>
            <TableCell>Entries</TableCell>
            <TableCell align="right"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?.map(
            (row, index) =>
              row !== null && row !== undefined && (
                <TableRow
                  key={index}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell component="th" scope="row">
                    {row.prizeDrawId}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.title}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {moment(row.drawDate).format("ddd MMM D, YYYY")}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {moment(row.submissionStartDate).format("ddd MMM D, YYYY")}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {moment(row.submissionEndDate).format("ddd MMM D, YYYY")}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row?.isFeatured ? (
                      <Iconify
                        icon={"eva:checkmark-circle-2-outline"}
                        sx={{ color: "green" }}
                      />
                    ) : (
                      <Iconify
                        icon={"eva:close-circle-outline"}
                        sx={{ color: "red" }}
                      />
                    )}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row?.entriesCount}
                  </TableCell>
                  <TableCell align="right">
                    <IconButton
                      size="large"
                      color="inherit"
                      onClick={(event) => {
                        handleOpenMenu(event, row)
                    }}
                      id={row.prizeDrawId}
                    >
                      <Iconify icon={"eva:more-vertical-fill"} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              )
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ActivePrizeDrawTable;
